import {State} from "./state";
import {getAllTags} from "../util/tags";

export function selectTags(state: State) {
  return state.tags.data;
}

export function selectInstruments(state: State) {
  return state.instruments.data;
}

export function selectInstrumentsSorted(state: State) {
  return [...state.instruments.data].sort((a, b) => a.name.localeCompare(b.name));
}

export function selectInstrumentsFiltered(state: State) {
  const instruments = selectInstruments(state);
  const selectedFilters = selectFilters(state);

  return instruments.filter(instrument => instrument.tagCategories.every(category => {
      const allTagsOfCat = getAllTags(category.tags);
      const selectedTagsOfCat = selectedFilters.filter(id => allTagsOfCat.some(tag => tag.id === id));
      return selectedTagsOfCat.length === 0 || selectedTagsOfCat.some(id => allTagsOfCat.find(tag => tag.id === id)?.selected);
    })
  );
}

export const selectInstrumentById = (id: string | undefined) => (state: State) => {
  if (!id) return undefined;
  return state.instruments.data.find(instrument => instrument.id === id);
}

export const selectIsAuthenticated = (state: State) => {
  return state.isAuthenticated;
}

export const selectMessage = (state: State) => {
  return state.message;
}

export const selectFilters = (state: State) => {
  return state.selectedFilters;
}